import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4f612c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "ws_notify",
  class: "toast-container position-fixed t-top-60 end-0 p-3 z-index-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}